"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Marker_1 = require("./Marker");
var PosterMarker = (function (_super) {
    tslib_1.__extends(PosterMarker, _super);
    function PosterMarker(config, rawData, version) {
        return _super.call(this, config, rawData, version) || this;
    }
    return PosterMarker;
}(Marker_1.Marker));
exports.PosterMarker = PosterMarker;
//# sourceMappingURL=PosterMarker.js.map